"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseClass_1 = __importDefault(require("./BaseClass"));
class Company extends BaseClass_1.default {
    constructor(apiV1, apiV2) {
        super(apiV1, apiV2);
    }
    /**
     * Get list companies
     * @returns Return list company
     */
    async getListCompany() {
        try {
            const data = await this._apiV2.companyAPI.getListCompanies();
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Get list user companies
     * @returns Return list company of users
     */
    async getListUserCompany(page, limit, clientId) {
        try {
            const data = await this._apiV2.companyAPI.getListUserCompanies(page, limit, clientId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to create company
     * @param payload - create company payload
     * @returns
     */
    async createCompany(payload) {
        try {
            const data = await this._apiV2.companyAPI.createCompany(payload);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to update company info
     * @param payload - update company payload
     * @returns
     */
    async updateCompany(payload) {
        try {
            const data = await this._apiV2.companyAPI.updateCompany(payload);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to attach payment method to company
     * @param companyId - company id
     * @param payload - payment method payload
     * @param clientId - client_id of service
     * @returns
     */
    async attachPaymentMethodToCompany(companyId, payload, clientId) {
        try {
            const data = await this._apiV2.companyAPI.attachPaymentMethod(companyId, payload, clientId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to detach payment method from company
     * @param companyId - company id
     * @param paymentMethodId - payment method id
     * @param clientId - client_id of service
     * @returns
     */
    async detachPaymentMethodToCompany(companyId, paymentMethodId, clientId) {
        try {
            const data = await this._apiV2.companyAPI.detachPaymentMethod(companyId, paymentMethodId, clientId);
            if (!data.result) {
                return data;
            }
            const respBody = {
                result: data.result,
                entities: {
                    companies: data.entities,
                },
            };
            return respBody;
        }
        catch (error) {
            this._handleError(error);
        }
    }
}
exports.default = Company;
